"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _en = _interopRequireDefault(require("i2l?query=sporks!i18n-data/data/locales/en"));

var _legacyI18nInit = require("../../internal/legacyI18nInit");

var _default = function _default(Provider) {
  return Provider.register(_en.default, {
    getLocales: _legacyI18nInit.getLangEnabledLocales
  });
};

exports.default = _default;
module.exports = exports.default;